<ng-container *ngrxLet="uiService.isMobileView as isMobileView">
  <div class="flex flex-col gap-[20px] justify-start items-center">
    <mat-form-field mat-select-height-large [ngStyle]="{ width: isMobileView ? '300px' : '400px' }">
      <mat-label>{{ 'DIAGNOSTICS.CONTROL_UNIT' | translate }}</mat-label>
      <mat-select
        data-at-remote-diagnostics-control-unit-dropdown
        gtm="onOpen"
        gtmAction="Open control unit dropdown"
        gtmCategory="diagnosticsPage"
        (selectionChange)="onControlUnitOptionChange($event.value)"
        [value]="currentControlUnit"
        [compareWith]="compareControlUnits"
        fieldTextContentTooltip
      >
        <mat-option
          *ngFor="let controlUnit of remoteDiagnosticsStore.getControlUnits(gatewaySerial) | async"
          [value]="controlUnit"
          gtm="onSelect"
          gtmAction="Control unit: '{{ controlUnit.value }}'"
          gtmCategory="diagnosticsPageHeader"
          fieldTextContentTooltip
          [attr.data-at-control-unit]="controlUnit.value"
          >{{ controlUnit.objectProperty | translate }} {{ controlUnit.busType | translate }}:
          {{ controlUnit.busAddress }}</mat-option
        >
      </mat-select>
    </mat-form-field>
    <vi-dropdown-autocomplete
      *ngIf="
        !(remoteDiagnosticsStore.loading$ | async) &&
        availableParametersExceptSelected?.length &&
        currentControlUnit
      "
      data-at-remote-diagnostics-parameter-name-dropdown
      placeholder="{{ 'DIAGNOSTICS.PARAMETER' | translate }}"
      [width]="isMobileView ? '300px' : '400px'"
      [options]="availableParametersExceptSelected"
      [elementHeight]="remoteDiagnosticsUiService.virtualScrollElementHeight$ | async"
      (optionChange)="addParameter($event)"
    ></vi-dropdown-autocomplete>
    <div *ngIf="remoteDiagnosticsStore.loading$ | async">
      {{ '+GENERAL.LOADING_DATA' | translate }}
    </div>
  </div>
</ng-container>
